export default __webpack_public_path__ + "media/images/logo-light-6e772a405de30eac928bc5dc9f54b215.svg";